import { arrEquals } from "../functions";

class Product {
  static getStock(product, features) {
    let stock = null;

    if (product) {
      if (product.body.stock && product.body.stockFeatures.length > 0) {
        if (product.body.features.length === 0) {
          const quantity = parseInt(product.body.stockFeatures[0].quantity);

          stock = {
            ...product.body.stockFeatures[0],
            quantity
          };
        } else {
          const options = [];

          for (let i = 0; i < features.length; i++) {
            if (Boolean(features[i].option)) {
              options.push(features[i].option.value);
            }
          }

          for (let i = 0; i < product.body.stockFeatures.length; i++) {
            const sf = product.body.stockFeatures[i];
            const keys = Object.keys(sf).filter(k => k !== "quantity");
            const sfo = [];

            keys.forEach(k => sfo.push(sf[k].options.value));

            if (arrEquals(options, sfo)) {
              const quantity = parseInt(sf.quantity);

              stock = {
                ...sf,
                quantity
              };
              break;
            }
          }
        }
      }
    }

    return stock;
  }
}

export default Product;
